import { createStyles } from "../Utilities/ThemeHelper";
export const styles = createStyles(theme => ({
  root: {
    // SkeletonTheme renders a div in v2
    // Replace with custom span wrapper
    // https://github.com/dvtng/react-loading-skeleton/issues/46
    "& .react-loading-skeleton": {
      backgroundColor: props => props.color,
      backgroundImage: props => `linear-gradient(
					90deg,
					${props.color},
					${props.disableAnimation ? "transparent" : "rgba(0,0,0,.10)"},
					${props.color}
				)`
    }
  },
  disableAnimation: {
    "& span[style]": {
      animation: "none !important",
      backgroundImage: "none"
    }
  }
}));